import { Users, Lock, HandHelping, ClipboardCheck } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const items = [
  {
    icon: Users,
    title: "Participation avec problématique ou comme représentant",
    desc: "Deux rôles complémentaires, chacun a sa valeur dans le travail du groupe.",
  },
  {
    icon: Lock,
    title: "Cadre confidentiel",
    desc: "Ce qui se dit et se vit pendant la journée reste dans le groupe.",
  },
  {
    icon: HandHelping,
    title: "Travail accompagné",
    desc: "Le cadre est tenu de bout en bout. Vous n'êtes jamais seul face à ce qui émerge.",
  },
  {
    icon: ClipboardCheck,
    title: "Inscription obligatoire",
    desc: "Pour préserver la qualité du travail et la dynamique du groupe.",
  },
];

export default function CalInfoReminder() {
  return (
    <section
      data-testid="cal-info"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Bon à savoir
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Informations pratiques
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 gap-5">
          {items.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 0.07}>
              <div
                data-testid={`cal-info-item-${i}`}
                className="h-full p-7 bg-white rounded-3xl border border-[#DDD7E2] flex gap-5"
              >
                <span className="flex-shrink-0 w-11 h-11 rounded-full bg-[#F3EEF4] flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#3A2E6E]" />
                </span>
                <div>
                  <h3 className="font-serif-display text-xl text-[#1E1E2A] leading-tight">
                    {title}
                  </h3>
                  <p className="mt-2 text-sm text-[#5F6170] leading-relaxed">{desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
